// Cloud Run environment - points to local nginx proxy
export const apiURL = `/v1`;
export const BASIC_AUTH_USERNAME = "com.development.rivela.dev";
export const BASIC_AUTH_PASSWORD = "riveladevelopment";

// Dynamic runtime configuration with fallback
export const urlSmartbeat = window.RUNTIME_CONFIG?.urlSmartbeat && window.RUNTIME_CONFIG.urlSmartbeat !== "URL_SMARTBEAT_PLACEHOLDER"
  ? window.RUNTIME_CONFIG.urlSmartbeat
  : "";
